import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import ExpertServiceMap from './ExpertServiceMap';
const ExpertMapView = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'user'
        });
    }, []);
    return (
        <>
            <PageHeaderLayout headerTitle={'CuDel Expert Service Map'}></PageHeaderLayout>
           <ExpertServiceMap/> 
        </>
    )
}

export default ExpertMapView;